import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { MdbTableDirective } from "ng-uikit-pro-standard";
import { Router } from "@angular/router";
import { ScheduleType, ProductType } from "src/app/core/product/enums";
import { Product } from "src/app/core/product/product.model";
import { AppService } from "src/app/core/app/app.service";

@Component({
  selector: "ll-passes-table",
  templateUrl: "./passes-table.component.html",
  styleUrls: ["./passes-table.component.scss"]
})
export class PassesTableComponent implements OnInit {
  @Input() products: Product[];

  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;
  public begin: number;
  public end: number;
  public items: number;
  constructor(public app: AppService, public router: Router) {
    this.begin = 0;
    this.items = 10;
    this.end = this.begin + this.items;
  }

  public get currentSearchText(): string {
    return this.app.state.passFilterSearchText;
  }

  ngOnInit() {}

  ngAfterViewInit() {}

  openAddPass() {
    this.app.isBundleForm = false;
    this.app.addProductBuilder();
    return;
  }
  itemsPerPage: number[] = [5, 10, 25, 50];

  show(i: number) {
    return i < this.end && i >= this.begin;
  }
  increment(length: number) {
    let overlap: boolean = length <= this.end;
    if (overlap) return;
    this.begin += this.items;
    this.end += this.items;
  }
  decrement() {
    let overlap: boolean = this.begin - this.items < 0;
    if (overlap) return;
    this.begin -= this.items;
    this.end -= this.items;
  }
  setItemsPerPage(item: number) {
    this.items = item;
    this.begin = 0;
    this.end = item;
    this.mdbTable.setDataSource(this.products);
  }

  schedule_mask = (type: ScheduleType) => {
    switch (type) {
      case ScheduleType.Continuous:
        return "Continuous";
      case ScheduleType.CustomDays:
        return "Custom Days";
      case ScheduleType.DayOfWeek:
        return "Day of Week";
    }
  };

  getType(i: number): string {
    return ProductType[i];
  }
  get toPassForm(): string[] {
    return ["pass-form"];
  }
  get toScheduleForm(): string[] {
    return ["schedule-form"];
  }
  
  isError(pass: Product) {
    return false;
  }

  isHidden(pass: Product): boolean {
    return !pass.isActive;
  }

  edit(product: Product) {
    if (product.productType == ProductType.Bundle) this.app.isBundleForm = true;
    this.app.editProductBuilder(product);
  }

  public filter(products: Product[]): Product[] {
    return products.filter(product => {
      let searchFlag: boolean =
        this.currentSearchText == null ||
        this.currentSearchText == "" ||
        product.shared.name.includes(this.currentSearchText);
      return searchFlag;
    });
  }

  addBundle() {
    this.app.isBundleForm = true;
    this.app.addProductBuilder();
    return;
  }
}
